import React, { useContext, useMemo, memo } from "react";
import { useLocation } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { HotelContext } from "../context/HotelContext";
import { useV2PreferredRedirect } from "../hooks/useV2PreferredRedirect";
import Slidebar from "../component/Slidebar";
import Navbar from "../utils/Navbar";
import Dashboard from "./Dashboard";
import Consommation from "./consommation";
import Economies from "./economies";
import Badges from "./Badges";
import Statistics from "./Statistiques";
import Donation from "./donation";

// Mémoriser les composants pour éviter les re-renders inutiles
const MemoizedDashboard = memo(Dashboard);
const MemoizedConsommation = memo(Consommation);
const MemoizedEconomies = memo(Economies);
const MemoizedBadges = memo(Badges);
const MemoizedStatistics = memo(Statistics);
const MemoizedDonation = memo(Donation);

const V1Layout = () => {
  const { hId } = useContext(HotelContext);
  const location = useLocation();
  const path = location.pathname;

  useV2PreferredRedirect();

  // Déterminer le viewID depuis l'URL
  const viewID = useMemo(() => {
    if (path.includes("/dashboard")) return "dashboard";
    if (path.includes("/consommation")) return "consommation";
    if (path.includes("/economies")) return "economies";
    if (path.includes("/badges")) return "badges";
    if (path.includes("/stats")) return "stats";
    if (path.includes("/donation")) return "donation";
    return "dashboard";
  }, [path]);

  // Rendre le composant correspondant selon le viewID (mémorisé pour éviter les re-renders)
  const content = useMemo(() => {
    switch (viewID) {
      case "dashboard":
        return <MemoizedDashboard />;
      case "consommation":
        return <MemoizedConsommation />;
      case "economies":
        return <MemoizedEconomies />;
      case "badges":
        return <MemoizedBadges />;
      case "stats":
        return <MemoizedStatistics />;
      case "donation":
        return <MemoizedDonation />;
      default:
        return <MemoizedDashboard />;
    }
  }, [viewID]);

  return (
    <div className="App">
      <Row className="Row_Content">
        <Navbar />
        {hId && (
          <Col xs="3" className="sidebarBloc">
            <Slidebar viewID={viewID} path={path} />
          </Col>
        )}
        {hId ? (
          <Col xs="9" className="mainBloc">
            <div className="mainContent">
              {/* Outlet pour les routes enfants, mais on rend directement le contenu pour éviter le refresh */}
              {content}
            </div>
          </Col>
        ) : null}
      </Row>
    </div>
  );
};

export default V1Layout;

